import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';

import GetPaginatedReasonCodesQuery from '@/graphql/contracts/getPaginatedReasonCodes.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetPaginatedReasonCodes,
  GetPaginatedReasonCodesVariables
} from '@/graphql/contracts/_generated_/getPaginatedReasonCodes.query';
import { REASON_CODES_PER_PAGE } from '@/config/common.config';
import { notificationService } from '@/services/notification/notification.client';

export function useGetPaginatedReasonCodes() {
  const [reasonCodes, setReasonCodes] = useState<ReasonCode[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  const [_getReasonCodes, { data, loading }] = useLazyQuery<GetPaginatedReasonCodes, GetPaginatedReasonCodesVariables>(
    GetPaginatedReasonCodesQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const getReasonCodes = (reasonType: string, pageNumber: number) => {
    _getReasonCodes({
      variables: {
        type: reasonType,
        pageNumber: pageNumber,
        pageSize: REASON_CODES_PER_PAGE,
        includeDisabled: true
      },
    });
  };

  useEffect(() => {
    setReasonCodes(data?.paginatedReasonCodes?.data ?? []);
    setTotalPages(data?.paginatedReasonCodes?.totalPages ?? 0);
  }, [data]);

  return {
    getReasonCodes,
    reasonCodes,
    totalPages,
    isLoading: loading
  } as const;
}
